import { ToursList } from './Components/ToursList/ToursList';

export const Tours = () => <ToursList />;
